import React from 'react'
import styled from 'styled-components'
import {TreeSearchFototreeResponse} from 'types'
import convertUnit from 'lib/unit'
import {Icon, IconVerifiedBadge, ListItemSelect} from 'common/components'
import {useTranslation} from 'i18n'
import {formatDateRange, showSnackbar} from 'utils'

const StyledIconVerifiedBadge = styled(IconVerifiedBadge)`
  display: inline-block;
  line-height: ${convertUnit(12)};
`

export function GiftshopTemplateUploadFormTagsTagItem({
  item,
  selectedTags,
  handleSelect,
  type,
}: {
  item: TreeSearchFototreeResponse
  selectedTags: TreeSearchFototreeResponse[]
  handleSelect: (selectedItem: TreeSearchFototreeResponse) => void
  type: 'search-result' | 'last-used'
}) {
  const {translate} = useTranslation()

  return (
    <ListItemSelect
      title={item.name}
      style={{
        paddingLeft: convertUnit(13),
      }}
      titleRighIcon={
        item.status === 'VERIFIED' ? <StyledIconVerifiedBadge /> : <></>
      }
      leftElement={
        <Icon
          type={type === 'last-used' ? 'history' : 'tree-feature'}
          style={{
            paddingRight: convertUnit(13),
          }}
        />
      }
      overflowSubtitle={`${
        item.host_fee
          ? `${translate('giftShop:uploadTagHostFeeFototreeDesc', {
              hostFee: item.host_fee,
            })}`
          : ''
      }
        ${
          item.host_fee && (item.event_end_date || item.event_start_date)
            ? ' | '
            : ''
        }
        ${
          item.event_end_date && item.event_start_date
            ? `${formatDateRange(item.event_start_date, item.event_end_date)}`
            : ''
        }
        ${
          (item.host_fee || item.event_end_date || item.event_start_date) &&
          item.bio
            ? ' | '
            : ''
        }
        ${item.bio ? `${item.bio}` : ''}`}
      hoverColor="white_3"
      titleHoverColor="black"
      onClick={() => {
        if (selectedTags.length === 0) {
          handleSelect(item)
        } else {
          showSnackbar(
            translate('giftShop:fototreeCannotAddMoreThanOneSnackbar'),
          )
        }
      }}
    />
  )
}
